// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2KDe6","list":"styles_list__2ZUxJ","item":"styles_item__3g71q"};